/* Casemira, bloc avis de la fiche produit, part JS.       C5, 05/09/2026
   N'ECRIT AUCUN CONTENU et n'ouvre aucune requete : tout est deja dans la
   page. Cinq gestes au clic : reveler des cartes, ouvrir la bulle de
   transparence, ouvrir la loupe, zoomer dedans, faire defiler la bande de
   photos. L'histogramme est parti le 06/09 (G6.4b, modele Benuta) ; il avait
   deja perdu son filtre le 05/09 (G1.3).
   Le POURQUOI est dans l'en-tete de la section Liquid, dont les commentaires
   ne partent pas chez le visiteur. Mesure du 06/09, apres G6.4b : ce fichier
   pese 8,8 Ko gzip (26,3 Ko brut) et la feuille 13,9 Ko gzip (44,6 Ko brut),
   commentaires compris. Ce sont les octets REELS, ceux qui partent chez le
   visiteur : les deux fichiers sont servis tels quels par le CDN Shopify, qui
   ne retire pas les commentaires. Le budget de 6 Ko annonce le 05/09 etait
   depasse depuis G3.3 (le zoom et la vue agrandie), et il n'avait pas ete
   remesure ; on ecrit desormais la mesure, pas la promesse.

   La loupe s'ouvre depuis la vignette ET depuis la carte entiere (retour Raph
   du 05/09). Son panneau de texte est rempli par CLONAGE de la carte : aucune
   chaine n'est fabriquee ici, donc rien a traduire dans ce fichier. Les deux
   phrases du compteur (« 2 / 3 » et « Photo 2 sur 3 ») arrivent en attributs,
   deja traduites par le serveur : meme regle, tenue.

   G3.3 (05/09) : la vue agrandie prend le dessin valide par Raph. Le zoom
   (clic a 2x avec point fixe, deplacement souris, pincement a 4x) et la
   navigation entre les photos de l'avis sont ici ; leur dessin, dans la
   feuille ; le POURQUOI, dans la section Liquid.

   G6.4b (06/09) : la bande de photos. Elle est ECRITE PAR LE SERVEUR, comme
   tout le reste ; ce fichier ne lui ajoute que deux choses qu'aucune feuille ne
   sait faire : reveler ses fleches SI la piste deborde vraiment, et retrouver
   la carte d'un avis a partir de l'index que la vignette porte, pour rouvrir
   dessus la loupe qui existait deja. */
(function () {
  'use strict';

  /* DEUX au chargement, QUATRE de plus a chaque clic (G5.5, 06/09, retour de
     Raph : « on n'est pas oblige d'en mettre autant »). `DEPART` doit rester
     egal a `montre_au_depart` dans la section Liquid, qui ecrit les deux
     premieres cartes visibles : le JS reprend le compte a partir de la, il ne
     le refait pas. Les deux valeurs sont PAIRES : la grille est a deux
     colonnes au-dela de 768 px, les rangees restent donc pleines. */
  var DEPART = 2;
  var PAS = 4;
  function liste(r, sel) { return Array.prototype.slice.call(r.querySelectorAll(sel)); }

  /* ── LE CARRE DORE QUI RESTAIT APRES UN TOUCHER (G9.3, 06/09) ────────────
     Retour de Raph, sur iPhone : « apres un clic ou un toucher sur une carte
     d'avis, un carre dore reste autour ». C'est l'anneau de focus, et toutes
     nos regles le posent deja en `:focus-visible`, ce qui devait suffire.
     Cela ne suffit pas : `:focus-visible` laisse au navigateur le soin de
     decider pour les elements qui ne sont PAS des commandes natives, et Safari
     decide de le montrer des qu'un element rendu focalisable par `tabindex`
     recoit le focus, POINTEUR COMPRIS. Or la carte d'avis est exactement cela :
     un `<li tabindex="0">`, choisi en G1.2 parce qu'un bouton dans un bouton
     n'existe pas. L'anneau restait donc au doigt, sur les deux surfaces.

     ON N'EFFACE PAS L'ANNEAU, ON SE SOUVIENT DU DERNIER GESTE. L'attribut
     `data-cm-pointeur` est pose sur la racine du document a chaque
     `pointerdown` et retire a la premiere touche du clavier ; la feuille ne
     tait l'anneau que TANT QU'IL EST LA. Une tabulation, une fleche, Echap :
     l'attribut part avant que le focus ne bouge (les deux ecouteurs sont en
     CAPTURE, donc avant tout gestionnaire), et l'anneau revient entier. Le
     clavier ne perd rien, jamais.

     C'EST POSE UNE FOIS POUR LE DOCUMENT, pas par bloc : deux exemplaires du
     meme drapeau seraient deux verites a tenir. La page avis pose le meme
     attribut, avec le meme nom, pour la meme raison ; l'un ou l'autre suffit,
     les deux ensemble ne se genent pas. */
  var racineDoc = document.documentElement;
  /* Le TYPE du dernier pointeur sert a un second usage, plus bas : sur un
     telephone, une tape emet aussi un `mousemove` de compatibilite, et ce
     faux mouvement de souris promenait la photo zoomee avant que le clic ne
     la remette a plat. */
  var dernierPointeur = '';
  document.addEventListener('pointerdown', function (e) {
    dernierPointeur = (e && e.pointerType) || '';
    racineDoc.setAttribute('data-cm-pointeur', '');
  }, true);
  document.addEventListener('keydown', function () {
    racineDoc.removeAttribute('data-cm-pointeur');
  }, true);

  function monter(racine) {
    var cartes = liste(racine, '[data-cma-carte]');
    if (!cartes.length) return;

    /* Vignette manquante : on remet l'original. En capture, et EN PREMIER (une
       image visible peut echouer avant la fin du montage).

       DANS UN `<picture>`, POSER `src` NE SUFFIT PAS (fix G6.4b, revue 2b).
       Les trois premieres vignettes de la bande vivent dans un `<picture>` avec
       un `<source media="(min-width: 768px)">`. Or toute modification de
       l'`<img>` relance la SELECTION de source, et cette selection repart des
       `<source>` : sur ordinateur, le `<source>` reimposait la miniature
       `__compact` qui venait justement d'echouer, et le filet tournait a vide
       (au mieux) ou en boucle d'erreurs (au pire).
       Le `<source>` defaillant est donc RETIRE avant que `src` soit pose : il
       ne reste que l'`<img>`, et l'`<img>` prend l'original. On ne retire que
       les `<source>` du `<picture>` qui porte CETTE image, jamais ceux d'une
       voisine, et la garde `img.src !== plein` ferme la boucle si l'original
       lui-meme echoue. */
    racine.addEventListener('error', function (e) {
      var img = e.target;
      if (!img || img.tagName !== 'IMG') return;
      var plein = img.dataset.cmaPlein;
      if (!plein || img.src === plein) return;
      var parent = img.parentElement;
      if (parent && parent.tagName === 'PICTURE') {
        var sources = parent.querySelectorAll('source');
        for (var i = 0; i < sources.length; i++) sources[i].remove();
      }
      img.src = plein;
    }, true);

    var boutonPlus = racine.querySelector('[data-cma-plus]');
    var resteBloc = racine.querySelector('[data-cma-reste-bloc]');
    var info = racine.querySelector('[data-cma-info]');
    var bulle = racine.querySelector('[data-cma-bulle]');
    var loupe = racine.querySelector('[data-cma-loupe]');
    var loupeCorps = racine.querySelector('[data-cma-loupe-corps]');
    var loupeImg = racine.querySelector('[data-cma-loupe-img]');
    var loupeCadre = racine.querySelector('[data-cma-loupe-cadre]');
    var loupeScene = racine.querySelector('[data-cma-loupe-scene]');
    var loupeTexte = racine.querySelector('[data-cma-loupe-texte]');
    var loupeAide = racine.querySelector('[data-cma-loupe-aide]');
    var loupePied = racine.querySelector('[data-cma-loupe-pied]');
    var loupeCompte = racine.querySelector('[data-cma-loupe-compte]');
    var loupeCompteVu = racine.querySelector('[data-cma-loupe-compte-vu]');
    var loupeCompteLu = racine.querySelector('[data-cma-loupe-compte-lu]');
    var flechePrec = racine.querySelector('[data-cma-loupe-pas="-1"]');
    var flecheSuiv = racine.querySelector('[data-cma-loupe-pas="1"]');
    var piste = racine.querySelector('[data-cma-bande-piste]');
    var bandeFleches = liste(racine, '[data-cma-bande-pas]');
    var bandeVignettes = liste(racine, '[data-cma-bande-photo]');
    var montrees = DEPART;
    /* Les photos de l'avis ouvert, et celle qu'on regarde. */
    var vignettes = [];
    var iPhoto = 0;

    function rendu() {
      for (var i = 0; i < cartes.length; i++) cartes[i].hidden = i >= montrees;
      /* Gisement epuise : le bouton cede la place a la phrase de compte, deja
         ecrite par le serveur. Le nombre de colonnes, lui, ne bouge plus : il
         est ecrit une fois par le serveur, plus rien ne retire de carte. */
      var epuise = cartes.length <= montrees;
      if (resteBloc) resteBloc.hidden = !epuise;
      if (boutonPlus) boutonPlus.hidden = epuise;
      mesurerSuites();
    }

    /* ── « LIRE LA SUITE » NE S'AFFICHE QUE S'IL Y A UNE SUITE ─────────────
       Le plafond de trois lignes est pose par la feuille, donc des le premier
       pixel peint ; ce qu'aucune feuille ne sait dire, c'est SI le texte a ete
       coupe. Une seule mesure le dit : la hauteur reelle du contenu contre
       celle de la boite. Le signe est hors du flux : le devoiler ne deplace
       rien (zero CLS), et un avis de deux lignes ne promet pas de suite.
       La mesure ne porte que sur les cartes VISIBLES : une carte masquee a des
       hauteurs nulles, et elle repassera ici quand « voir plus » la revelera.
       Le pixel de marge absorbe les arrondis sub-pixels du navigateur. */
    function mesurerSuites() {
      for (var i = 0; i < cartes.length; i++) {
        if (cartes[i].hidden) continue;
        var corps = cartes[i].querySelector('[data-cma-corps]');
        var suite = cartes[i].querySelector('[data-cma-suite]');
        if (!corps || !suite) continue;
        suite.hidden = corps.scrollHeight <= corps.clientHeight + 1;
      }
    }

    /* LA PREMIERE MESURE TOMBE AVANT LES POLICES. `rendu()` s'execute au
       montage, donc sur la fonte de repli : Instrument Sans est plus etroite,
       et un avis qui debordait de trois lignes en repli tient parfois dedans
       une fois la vraie fonte arrivee. Sans ce rappel, le signe restait
       affiche sur un texte qui n'etait plus coupe. `document.fonts` manque sur
       les navigateurs les plus anciens : la mesure du montage y reste la
       derniere, et elle est deja juste a la fonte pres. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(mesurerSuites);
    }

    /* La largeur de la carte change avec celle de la fenetre, donc le nombre de
       lignes aussi : un avis coupe en portrait tient parfois en trois lignes en
       paysage. Une seule image par trame, et rien tant que la fenetre bouge. */
    var attente = 0;
    window.addEventListener('resize', function () {
      if (attente) return;
      attente = window.requestAnimationFrame(function () {
        attente = 0;
        mesurerSuites();
        /* La piste change de largeur avec la fenetre : trois vignettes qui
           debordaient en portrait tiennent parfois en paysage. */
        reglerBande();
      });
    });

    /* ── LE ⓘ DE TRANSPARENCE ────────────────────────────────────────────
       Meme comportement que celui de la banniere de reassurance : second clic,
       clic dehors et Echap referment, `aria-expanded` dit l'etat. La bulle est
       hors du flux, l'ouvrir ne deplace rien. */
    function bascule(ouvrir) {
      if (!info || !bulle) return;
      bulle.hidden = !ouvrir;
      info.setAttribute('aria-expanded', ouvrir ? 'true' : 'false');
    }
    if (info && bulle) {
      document.addEventListener('click', function (e) {
        if (bulle.hidden) return;
        if (!info.contains(e.target) && !bulle.contains(e.target)) bascule(false);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' || bulle.hidden) return;
        bascule(false);
        info.focus();
      });
    }

    /* ── LA BANDE DE PHOTOS (G6.4b) ──────────────────────────────────────
       DEUX CHOSES, ET PAS UNE DE PLUS.

       1. LES FLECHES NE SE MONTRENT QUE SI ELLES SERVENT. Une feuille ne sait
          pas dire si une piste deborde : seule une mesure le dit
          (`scrollWidth` contre `clientWidth`). Sur une fiche a trois photos et
          un ecran large, la piste tient entiere et les fleches resteraient deux
          ronds inertes. Elles naissent donc `hidden` cote serveur, et ne sont
          revelees qu'ici. Elles sont HORS DU FLUX : les reveler ne pousse rien
          (zero CLS).
          Le pointeur grossier n'en a pas besoin : au doigt, la piste se pousse.
          `matchMedia` manque sur les navigateurs les plus anciens : ils ont
          alors les fleches, ce qui est le repli sur.

       2. AU BOUT, LA FLECHE SE TAIT SANS PARTIR. `disabled` et non `hidden` :
          retirer un rond ferait sauter l'autre de 44 px. Le seuil de 2 px
          absorbe les arrondis sub-pixels du defilement.

       Le PAS est de 80 % de la largeur visible : la vignette qui fermait la vue
       reste a l'ecran, et l'oeil ne perd pas le fil.
       `scroll-behavior` est laisse a la feuille et au reglage du visiteur :
       `behavior: 'smooth'` en dur ignorerait `prefers-reduced-motion`. */
    var attenteBande = 0;
    function reglerBande() {
      if (!piste || !bandeFleches.length) return;
      var deborde = piste.scrollWidth > piste.clientWidth + 2;
      var grossier = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      var montre = deborde && !grossier;
      var x = piste.scrollLeft;
      var fin = piste.scrollWidth - piste.clientWidth;
      for (var i = 0; i < bandeFleches.length; i++) {
        var f = bandeFleches[i];
        f.hidden = !montre;
        var pas = parseInt(f.dataset.cmaBandePas, 10) || 0;
        f.disabled = pas < 0 ? x <= 2 : x >= fin - 2;
      }
    }
    function defilerBande(pas) {
      if (!piste) return;
      piste.scrollLeft += pas * Math.round(piste.clientWidth * 0.8);
    }

    /* ── LE PARCOURS GLISSANT DE LA PISTE (fix G6.4b, revue 1) ───────────
       UN SEUL ARRET DE TABULATION POUR TOUTE LA BANDE. Le serveur pose
       `tabindex="0"` sur la premiere vignette et `-1` sur les vingt-trois
       autres ; ici, les fleches gauche et droite deplacent le foyer d'une
       vignette a l'autre et font glisser l'attribut avec lui. C'est le motif
       de parcours que les guides ARIA appellent « roving tabindex », et c'est
       le seul qui rende une piste de vingt-quatre images franchissable a la
       tabulation : sans lui, il fallait vingt-quatre Tab pour passer de la
       note au premier avis. `Home` et `End` sautent aux deux bouts.
       `scrollIntoView` en `nearest` : la vignette focalisee entre dans la vue
       sans recentrer la piste ni faire bouger la page autour. Il n'est appele
       QUE sur un deplacement volontaire, donc jamais au chargement. */
    function foyerVignette(i) {
      if (i < 0 || i >= bandeVignettes.length) return;
      for (var k = 0; k < bandeVignettes.length; k++) {
        bandeVignettes[k].tabIndex = k === i ? 0 : -1;
      }
      /* `preventScroll` D'ABORD, `scrollIntoView` ENSUITE (fix G6.4b, revue 2).
         Un `focus()` nu fait defiler le navigateur A SA FACON pour amener
         l'element dans la vue, puis notre `scrollIntoView` refaisait le trajet
         a la sienne : deux defilements pour un seul appui de touche, et la
         page qui sursaute autour de la piste. On coupe le premier et on garde
         le notre, qui est borne a `nearest` sur les deux axes.
         L'option n'est pas connue partout : sur un navigateur qui l'ignore, le
         comportement est celui d'avant, jamais pire. */
      try {
        bandeVignettes[i].focus({ preventScroll: true });
      } catch (e) {
        bandeVignettes[i].focus();
      }
      if (bandeVignettes[i].scrollIntoView) {
        bandeVignettes[i].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }
    if (piste && bandeVignettes.length) {
      piste.addEventListener('keydown', function (e) {
        var fin = bandeVignettes.length - 1;
        var vise;
        /* Debut et fin de piste : deux touches, deux lignes, et le parcours
           d'une bande de vingt-quatre cesse d'etre une course. */
        if (e.key === 'ArrowRight') vise = 1;
        else if (e.key === 'ArrowLeft') vise = -1;
        else if (e.key === 'Home') vise = 'debut';
        else if (e.key === 'End') vise = 'fin';
        else return;
        var ici = bandeVignettes.indexOf(
          e.target && e.target.closest ? e.target.closest('[data-cma-bande-photo]') : null
        );
        if (ici < 0) return;
        e.preventDefault();
        if (vise === 'debut') foyerVignette(0);
        else if (vise === 'fin') foyerVignette(fin);
        else foyerVignette(ici + vise);
      });
    }
    if (piste) {
      /* Une seule mise a jour par trame : le defilement emet des dizaines
         d'evenements par seconde, et l'etat des fleches n'est qu'un booleen. */
      piste.addEventListener('scroll', function () {
        if (attenteBande) return;
        attenteBande = window.requestAnimationFrame(function () {
          attenteBande = 0;
          reglerBande();
        });
      });
      /* Les vignettes arrivent en `lazy` : la piste ne prend sa vraie largeur
         qu'une fois les premieres posees. Une mesure au montage suffirait a
         voir le debordement (les carres ont leur taille par la feuille), mais
         le rappel a la charge coute une ligne et ferme le cas du navigateur
         qui reserve autrement. */
      window.addEventListener('load', reglerBande);
    }

    /* ── LE ZOOM (G3.3) ──────────────────────────────────────────────────
       Un seul etat, `{z, tx, ty}`, applique en `transform` : rien d'autre
       n'est anime. La photo NE QUITTE JAMAIS son cadre (voir `zBorne`). */
    var ZOOM_CLIC = 2, ZOOM_MAX = 4;
    var z = 1, tx = 0, ty = 0;
    var pointeurs = {}, pinceDep = 0, zDep = 1, glisse = null;

    function zApplique() {
      if (!loupeImg) return;
      loupeImg.style.transform = 'translate(' + tx.toFixed(1) + 'px,' + ty.toFixed(1) + 'px) scale(' + z + ')';
      if (loupeCadre) {
        loupeCadre.classList.toggle('is-zoom', z > 1);
        loupeCadre.setAttribute('aria-pressed', z > 1 ? 'true' : 'false');
      }
      if (loupeAide) loupeAide.hidden = z > 1;
    }
    /* Le debord maximal vaut la moitie de ce que l'agrandissement ajoute :
       sans cette borne, un deplacement rapide laisse un bord de voile la ou
       il devrait y avoir de la laine. */
    function zBorne() {
      var w = loupeImg.clientWidth, h = loupeImg.clientHeight;
      var lx = w * (z - 1) / 2, ly = h * (z - 1) / 2;
      tx = Math.max(-lx, Math.min(lx, tx));
      ty = Math.max(-ly, Math.min(ly, ty));
    }
    /* `glisse` retombe ici, et pas seulement au clic suivant : un pincement
       qui ne se termine par aucun clic laissait le drapeau leve, et la tape
       d'apres etait avalee par la garde. */
    function zRemet() { z = 1; tx = 0; ty = 0; glisse = null; zApplique(); }
    function zBascule(x, y) {
      if (z > 1) { zRemet(); return; }
      var r = loupeImg.getBoundingClientRect();
      if (!r.width) return;
      z = ZOOM_CLIC;
      /* Le point clique ne bouge pas : decalage = -(ecart au centre) x (z-1). */
      tx = -((x - (r.left + r.width / 2)) * (z - 1));
      ty = -((y - (r.top + r.height / 2)) * (z - 1));
      zBorne(); zApplique();
    }
    function nbPointeurs() { return Object.keys(pointeurs).length; }
    function ecart() {
      var k = Object.keys(pointeurs);
      var a = pointeurs[k[0]], b = pointeurs[k[1]];
      return Math.sqrt((a.x - b.x) * (a.x - b.x) + (a.y - b.y) * (a.y - b.y));
    }
    if (loupeCadre && loupeImg) {
      /* UN TOUCHER OU UN CLIC, LE MEME GESTE (G9.3, 06/09). Retour de Raph :
         « la loupe dit Pincer pour zoomer, mais sur iPhone c'est un toucher
         qui zoome ». La bascule est ici, et elle repond au `click` : une tape
         en emet un, avec les coordonnees du doigt. Le comportement etait donc
         deja le bon, c'est l'invite qui decrivait autre chose (voir la section
         Liquid et la cle `zoom_toucher`). Ce qui a ete ecrit ici, c'est la
         garde qui manquait : une tape emet AUSSI un `mousemove` de
         compatibilite, et lui seul faisait une difference visible entre les
         deux materiels. Le pincement natif, lui, n'a pas bouge (deux doigts,
         jusqu'a 4x). */
      loupeCadre.addEventListener('click', function (e) {
        if (glisse) { glisse = null; return; }
        zBascule(e.clientX, e.clientY);
      });
      /* Le cadre est une commande (role="button") : Entree et Espace zooment
         au CENTRE, seul point que le clavier sait designer. */
      loupeCadre.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
        e.preventDefault();
        var r = loupeCadre.getBoundingClientRect();
        zBascule(r.left + r.width / 2, r.top + r.height / 2);
      });
      loupeCadre.addEventListener('mousemove', function (e) {
        /* LE FAUX MOUVEMENT DE SOURIS DU TELEPHONE. Une tape emet, dans
           l'ordre, `pointerdown`, `pointerup`, `mousemove`, `mousedown`,
           `mouseup`, `click` : le `mousemove` arrive AVANT le clic et il n'a
           plus aucun pointeur en cours, donc les deux gardes du dessous le
           laissaient passer. Sur une photo deja zoomee, il la promenait au
           point touche juste avant que le clic ne la remette a plat : un
           sursaut, pour rien. On ne panoramique qu'a la souris. */
        if (dernierPointeur && dernierPointeur !== 'mouse') return;
        if (z <= 1 || nbPointeurs()) return;
        var r = loupeCadre.getBoundingClientRect();
        var fx = (e.clientX - r.left) / r.width - 0.5;
        var fy = (e.clientY - r.top) / r.height - 0.5;
        tx = -fx * loupeImg.clientWidth * (z - 1);
        ty = -fy * loupeImg.clientHeight * (z - 1);
        zBorne(); zApplique();
      });
      loupeCadre.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse') return;
        /* Un geste qui commence efface la trace du precedent. */
        glisse = null;
        loupeCadre.setPointerCapture(e.pointerId);
        pointeurs[e.pointerId] = { x: e.clientX, y: e.clientY };
        loupeCadre.classList.add('is-glisse');
        if (nbPointeurs() === 2) { pinceDep = ecart(); zDep = z; }
      });
      loupeCadre.addEventListener('pointermove', function (e) {
        if (!pointeurs[e.pointerId]) return;
        var av = pointeurs[e.pointerId];
        var dx = e.clientX - av.x, dy = e.clientY - av.y;
        pointeurs[e.pointerId] = { x: e.clientX, y: e.clientY };
        var n = nbPointeurs();
        if (n === 2 && pinceDep) {
          z = Math.max(1, Math.min(ZOOM_MAX, zDep * (ecart() / pinceDep)));
          if (z === 1) { tx = 0; ty = 0; }
          glisse = 1;
        } else if (n === 1 && z > 1) {
          tx += dx; ty += dy; glisse = 1;
        } else return;
        zBorne(); zApplique();
      });
      loupeCadre.addEventListener('pointerup', relacher);
      loupeCadre.addEventListener('pointercancel', relacher);
    }
    function relacher(e) {
      delete pointeurs[e.pointerId];
      if (!nbPointeurs()) loupeCadre.classList.remove('is-glisse');
    }

    /* ── FERMER LA LOUPE D'UN GLISSEMENT VERS LE BAS (G9.3, 06/09) ────────
       Retour de Raph : « fermer par un glissement du haut vers le bas, comme
       sur Instagram ». Le geste suit le doigt (la vue descend et s'eclaircit),
       il se decide au relachement, et il ne remplace RIEN : la croix reste,
       Echap reste, le clic sur le voile reste, et le focus revient au
       declencheur par le `<dialog>` natif, quel que soit le chemin de sortie.

       LES QUATRE GARDES, ET POURQUOI CHACUNE.
       1. AU DOIGT SEULEMENT (`pointerType !== 'mouse'`). A la souris, un
          glisser vers le bas est deja un panoramique de photo zoomee ou une
          selection ; et la souris a la croix sous la main.
       2. JAMAIS SUR UNE PHOTO ZOOMEE (`z > 1`). C'est la collision evidente :
          a 2x, un doigt qui descend DEPLACE la photo. Tant qu'on est zoome, le
          glissement appartient au zoom ; il faut d'abord degager (une tape).
       3. UN SEUL DOIGT. Le deuxieme doigt ouvre un pincement, pas une sortie ;
          si un second arrive en cours de route, le glissement est abandonne et
          la vue revient a sa place.
       4. PAS DEPUIS LE PANNEAU DE TEXTE (`[data-cma-loupe-texte]`), qui DEFILE
          verticalement : un avis long s'y lit au doigt, et fermer la vue au
          lieu de le faire defiler serait insupportable. Ni depuis une commande
          (croix, fleches), qui garde son clic.
       La piste de vignettes de la bande, elle, ne peut pas entrer en conflit :
       elle vit dans la page, pas dans le dialogue, et ces ecouteurs-ci sont
       poses sur le dialogue.

       LA DIRECTION SE VERROUILLE AU HUITIEME PIXEL. Tant qu'on n'a pas bouge
       de 8 px, on ne sait pas si le geste est vertical ; au-dela, si la part
       horizontale l'emporte ou si le doigt monte, le glissement est refuse
       pour de bon (`tirer.refuse`) et ne se rattrape pas en cours de route.

       DEUX FACONS DE FRANCHIR LE SEUIL, comme partout ailleurs : la DISTANCE
       (80 px, ou le quart de la hauteur si la fenetre est plus courte que 320
       px, pour que le geste reste faisable en paysage) ou la VITESSE (un jete
       vif, plus de 0,6 px par milliseconde vers le bas). Sinon, retour
       elastique a la place.

       `glisse` EST LEVE DES QUE LE GESTE PREND : c'est le meme drapeau que le
       zoom utilise pour qu'un glisser ne finisse pas en clic. Sans lui, un
       glissement qui n'atteint pas le seuil et qui se termine sur le voile
       fermait quand meme la vue, par le clic sur le fond. */
    var TIRER_MIN = 8, TIRER_SEUIL = 80, TIRER_VITESSE = 0.6;
    var tirer = null;
    /* LE MINUTEUR DU RETOUR ELASTIQUE SE RETIENT ET S'ANNULE (fix G9.3, revue
       1). Il retire la classe de transition 300 ms plus tard ; deux gestes
       rapproches en posaient deux, et celui du premier tombait au milieu du
       second, coupant sa transition en cours. On garde donc l'identifiant, et
       le geste suivant l'annule avant de commencer. */
    var tirerMinuteur = 0;

    function tirerSeuil() {
      var h = window.innerHeight || 0;
      return Math.min(TIRER_SEUIL, Math.max(24, Math.round(h * 0.25)));
    }
    function tirerPose(dy) {
      if (!loupeCorps) return;
      var h = window.innerHeight || 1;
      /* Le fondu est LEGER et borne : la vue s'eclaircit assez pour dire que
         le geste est pris, jamais assez pour qu'on ne la voie plus si on
         revient en arriere. */
      var o = Math.max(0.4, 1 - (dy / h) * 1.1);
      loupeCorps.style.transform = 'translateY(' + Math.round(dy) + 'px)';
      loupeCorps.style.opacity = o.toFixed(3);
    }
    /* La remise a plat est la MEME dans les deux issues : au retour elastique
       (avec la transition) et a la fermeture (sans, la vue disparait). */
    function tirerRemet(anime) {
      if (!loupeCorps) return;
      if (tirerMinuteur) { window.clearTimeout(tirerMinuteur); tirerMinuteur = 0; }
      loupeCorps.classList.toggle('cma-loupe-corps--retour', !!anime);
      loupeCorps.style.transform = '';
      loupeCorps.style.opacity = '';
      if (anime) {
        tirerMinuteur = window.setTimeout(function () {
          tirerMinuteur = 0;
          loupeCorps.classList.remove('cma-loupe-corps--retour');
        }, 300);
      }
    }
    if (loupe && loupeCorps) {
      loupe.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse') return;
        if (z > 1 || nbPointeurs() > 1) { tirer = null; return; }
        if (!e.target || !e.target.closest) return;
        if (e.target.closest('[data-cma-loupe-texte], button, a')) return;
        /* Le retour elastique du geste precedent n'a plus a se defaire : celui
           qui commence va reposer transform et opacite lui-meme. */
        if (tirerMinuteur) { window.clearTimeout(tirerMinuteur); tirerMinuteur = 0; }
        if (loupeCorps) loupeCorps.classList.remove('cma-loupe-corps--retour');
        tirer = { id: e.pointerId, x: e.clientX, y: e.clientY, dy: 0, t: Date.now(), pris: false, refuse: false };
      });
      loupe.addEventListener('pointermove', function (e) {
        if (!tirer || e.pointerId !== tirer.id || tirer.refuse) return;
        /* Un deuxieme doigt, ou un zoom entame entre-temps : le geste n'est
           plus une sortie, il rend la main sans rien laisser derriere lui. */
        if (z > 1 || nbPointeurs() > 1) { tirer = null; tirerRemet(true); return; }
        var dx = e.clientX - tirer.x;
        var dy = e.clientY - tirer.y;
        if (!tirer.pris) {
          if (Math.abs(dx) < TIRER_MIN && Math.abs(dy) < TIRER_MIN) return;
          if (dy <= 0 || Math.abs(dx) > Math.abs(dy)) { tirer.refuse = true; return; }
          tirer.pris = true;
        }
        tirer.dy = Math.max(0, dy);
        glisse = 1; /* ce geste n'est pas un clic */
        tirerPose(tirer.dy);
        /* CE `preventDefault` NE BLOQUE PAS LE DEFILEMENT, et il ne faut pas le
           lui faire dire (fix G9.3, revue 1) : le defilement est deja hors jeu,
           c'est `touch-action: none` sur la scene et sur le cadre qui l'ecarte,
           avant meme que l'evenement n'arrive ici. Ce qu'il ecarte, lui, ce sont
           les comportements par defaut qui suivent un geste tactile : les
           evenements de souris de compatibilite et la selection de texte que le
           doigt trainerait sur le panneau voisin. */
        if (e.cancelable) e.preventDefault();
      });
      var tirerFin = function () {
        if (!tirer) return;
        var pris = tirer.pris, dy = tirer.dy;
        var v = dy / Math.max(1, Date.now() - tirer.t);
        tirer = null;
        if (!pris) return;
        if (dy >= tirerSeuil() || v >= TIRER_VITESSE) {
          tirerRemet(false);
          if (loupe.open) loupe.close();
          return;
        }
        tirerRemet(true);
      };
      loupe.addEventListener('pointerup', tirerFin);
      loupe.addEventListener('pointercancel', tirerFin);
    }

    /* ── LE VERROU DE DEFILEMENT ─────────────────────────────────────────
       CE QUE `showModal()` NE FAIT PAS. Le `<dialog>` natif rend le reste de
       la page inerte (plus un clic, plus une tabulation) mais il ne retient
       PAS la molette : derriere la photo, la fiche continuait de defiler, et
       a la fermeture on se retrouvait ailleurs qu'a l'endroit quitte. Releve
       a la fenetre G, controle C6. La page avis, elle, posait deja son
       `body.ca-lb-open`.

       LE MOTIF EST CELUI DE LA MAISON (`casemira-guide-tailles.js`,
       `verrouille()` / `deverrouille()`) : `overflow: hidden` sur la RACINE
       et compensation de la largeur de la barre de defilement, mesuree AVANT
       de verrouiller. Jamais `position: fixed` sur le corps : cela perd la
       position de lecture et la rend au mauvais endroit.

       PAS DE `cm-over` ICI, ET C'EST DELIBERE. Cette classe arbitre l'ordre
       des SURCOUCHES du site (elle efface la bulle de chat et le bandeau de
       consentement, et six composants se la disputent). La loupe n'entre pas
       dans cet arbitrage : elle vit dans la couche superieure du navigateur,
       au-dessus de tout, sans rien avoir a effacer. Notre classe est a nous
       seuls, `cma-loupe-lock` : on ne retire que ce qu'on a pose, et le
       verrou d'un autre composant (panier, tiroirs) garde le sien. */
    var racineHtml = document.documentElement;
    function verrouille() {
      /* Mesure d'abord : une fois `overflow: hidden` pose, la barre a disparu
         et l'ecart mesure vaudrait zero. Si un autre verrou tient deja, la
         mesure vaut zero elle aussi, et c'est juste : la barre n'est plus la. */
      if (!racineHtml.classList.contains('cma-loupe-lock')) {
        racineHtml.style.setProperty('--cma-sbw', (window.innerWidth - racineHtml.clientWidth) + 'px');
      }
      racineHtml.classList.add('cma-loupe-lock');
    }
    function deverrouille() {
      racineHtml.classList.remove('cma-loupe-lock');
    }

    /* ── LA LOUPE ────────────────────────────────────────────────────────
       Un seul chemin d'ouverture, deux entrees : la vignette (sur SA photo)
       et la carte (sur la premiere photo, ou en texte seul). Les fleches et le
       compteur parcourent les photos de CET avis ; un avis a une seule photo
       n'a rien a parcourir ni a compter, les deux se retirent. */
    function remplir(modele, i, n) {
      return String(modele || '').split('[i]').join(i).split('[n]').join(n);
    }
    /* ── LA PHOTO QUI N'ARRIVE PAS (revue G24, 09/09) ──────────────────
       Les photos d'avis sont hebergees par Judge.me, un tiers : une URL
       perimee, un blocage reseau, un fichier retire, et l'image ne charge
       pas. La vue restait alors ouverte sur un LIT VIDE de la taille d'une
       photo, avec sa legende « Cliquez la photo pour zoomer » sous un cadre
       de 1 x 1 px et une carte etiree a 1080 px pour ne rien montrer.
       L'echec bascule donc dans le chemin qui existe deja et qui est le bon :
       celui de l'avis SANS photo. Le lit se retire, la carte se reduit a sa
       colonne de lecture, l'invite se tait. L'avis, lui, reste lisible, et
       c'est ce que le visiteur etait venu chercher.
       LE PIED N'EST PAS TOUCHE : s'il y a d'autres photos dans l'avis, la
       fleche « suivant » doit rester, et `poserPhoto` remet le lit en place
       des que l'une d'elles arrive. Un `src` absent n'est pas un echec (c'est
       le chemin sans photo, qui retire l'attribut) : la garde l'ecarte. */
    if (loupeImg) {
      loupeImg.addEventListener('error', function () {
        if (!loupeImg.getAttribute('src')) return;
        if (loupeScene) loupeScene.hidden = true;
        if (loupe) loupe.classList.add('cma-loupe--texte');
        if (loupeAide) loupeAide.hidden = true;
      });
    }
    function poserPhoto() {
      var b = vignettes[iPhoto];
      var sansPhoto = !b;
      if (loupeScene) loupeScene.hidden = sansPhoto;
      if (loupe) loupe.classList.toggle('cma-loupe--texte', sansPhoto);
      if (loupeImg) {
        if (sansPhoto) {
          loupeImg.removeAttribute('src');
          loupeImg.alt = '';
        } else {
          var v = b.querySelector('img');
          loupeImg.src = b.dataset.cmaPhoto;
          loupeImg.alt = v ? v.alt : '';
        }
      }
      /* Chaque photo montree repart a l'echelle 1 : le zoom de la precedente
         cadrerait au hasard sur la suivante. */
      zRemet();

      var n = vignettes.length;
      if (flechePrec) { flechePrec.hidden = n < 2; flechePrec.disabled = iPhoto <= 0; }
      if (flecheSuiv) { flecheSuiv.hidden = n < 2; flecheSuiv.disabled = iPhoto >= n - 1; }
      /* LE PIED SE RETIRE AVEC CE QU'IL PORTE (G24, 09/09). Depuis que les
         fleches et le compteur ont quitte la photo pour le pied de la colonne,
         les cacher un par un ne suffit plus : le pied lui-meme porte un filet
         et un rembourrage, et il serait reste une barre vide sous l'avis des
         qu'il n'y a rien a parcourir (une seule photo, ou aucune). C'est la
         MEME condition que la leur, ecrite une fois de plus, sur leur boite. */
      if (loupePied) loupePied.hidden = n < 2;
      if (loupeCompte) {
        loupeCompte.hidden = n < 2;
        if (n > 1) {
          /* Les deux modeles de phrase sont poses par le serveur, deja
             traduits : ce fichier n'ecrit aucun mot, il remplace des jetons. */
          if (loupeCompteVu) {
            loupeCompteVu.textContent = remplir(loupeCompte.dataset.cmaModele, iPhoto + 1, n);
          }
          if (loupeCompteLu) {
            loupeCompteLu.textContent = remplir(loupeCompte.dataset.cmaModeleLu, iPhoto + 1, n);
          }
        }
      }
    }
    function naviguer(pas) {
      var suivant = iPhoto + pas;
      if (suivant < 0 || suivant >= vignettes.length) return;
      iPhoto = suivant;
      poserPhoto();
    }
    function ouvrirLoupe(carte, depart) {
      if (!loupe) return;
      vignettes = carte ? liste(carte, '[data-cma-photo]') : [];
      iPhoto = depart > 0 && depart < vignettes.length ? depart : 0;
      poserPhoto();
      if (loupeTexte) {
        /* Clonage de ce que le serveur a deja ecrit : nom, date, badge
           « achat verifie », etoiles, corps de l'avis. Les vignettes ne
           suivent pas (la photo est deja a cote), et le panneau disparait
           s'il n'y a rien a montrer. */
        loupeTexte.textContent = '';
        /* `.cma-carte-signes` a remplace `.cma-carte-etoiles` dans cette
           liste (fix G9.3, revue 1) : les etoiles y sont toujours, et la date
           les a rejointes en quittant la tete de carte. Sans ce changement, le
           panneau perdait la date. Les vignettes, elles, voyagent avec la tete
           qu'elles habitent desormais, et la feuille les y masque. */
        /* `.cma-trad` (11/10/2026) : la mention « Traduit automatiquement » et
           l'original suivent le corps dans la loupe, dans l'etat de la carte. */
        var morceaux = carte
          ? liste(carte, '.cma-carte-tete, .cma-carte-signes, .cma-carte-corps, .cma-trad')
          : [];
        for (var i = 0; i < morceaux.length; i++) {
          loupeTexte.appendChild(morceaux[i].cloneNode(true));
        }
        /* L'original repart replie dans la loupe, quel que soit l'etat de la
           carte : meme geste que la page avis (11/10/2026). */
        var tradClones = liste(loupeTexte, '[data-cma-trad]');
        for (var j = 0; j < tradClones.length; j++) {
          var origClone = tradClones[j].querySelector('[data-cma-trad-original]');
          var boutonClone = tradClones[j].querySelector('[data-cma-trad-bouton]');
          if (origClone) origClone.hidden = true;
          if (boutonClone && boutonClone.getAttribute('data-cma-voir')) {
            boutonClone.textContent = boutonClone.getAttribute('data-cma-voir');
          }
        }
        loupeTexte.hidden = morceaux.length === 0;
      }
      if (loupe.showModal) {
        loupe.showModal();
        verrouille();
      }
    }

    racine.addEventListener('click', function (e) {
      var cible = e.target;
      if (!cible || !cible.closest) return; /* garde unique */

      if (info && cible.closest('[data-cma-info]')) {
        bascule(bulle.hidden); /* second clic = referme */
        return;
      }

      if (cible.closest('[data-cma-plus]')) {
        montrees += PAS;
        rendu();
        return;
      }

      /* « VOIR L'ORIGINAL » (11/10/2026, decision de Raph). Le bouton deplie le
         texte original de l'avis traduit, sur la carte comme dans la loupe (le
         dialogue est dans la racine). Les deux libelles sont ecrits par le
         serveur dans la langue de la page : ce fichier n'en fabrique aucun.
         Le libelle dit l'etat (Voir / Masquer) : pas d'`aria-expanded` en plus. */
      var tradBouton = cible.closest('[data-cma-trad-bouton]');
      if (tradBouton) {
        var tradBloc = tradBouton.closest('[data-cma-trad]');
        var original = tradBloc && tradBloc.querySelector('[data-cma-trad-original]');
        if (original) {
          var ouvrir = original.hidden;
          original.hidden = !ouvrir;
          var libelle = tradBouton.getAttribute(ouvrir ? 'data-cma-masquer' : 'data-cma-voir');
          if (libelle) tradBouton.textContent = libelle;
        }
        return;
      }

      /* LA BANDE, AVANT LES VIGNETTES DE CARTE : ses boutons portent un autre
         attribut (`data-cma-bande-photo`), donc les deux gestes ne se marchent
         jamais dessus, mais l'ordre dit lequel est lu en premier.
         L'index pointe la carte de l'avis : le serveur ecrit ses soixante
         cartes, `hidden` n'en efface aucune du DOM, et la loupe sait deja lire
         une carte masquee (elle y prend les URL, le texte et les etoiles). */
      var vignetteBande = cible.closest('[data-cma-bande-photo]');
      if (vignetteBande) {
        var iCarte = parseInt(vignetteBande.dataset.cmaAvis, 10);
        var carteBande = cartes[iCarte];
        if (carteBande) {
          ouvrirLoupe(carteBande, parseInt(vignetteBande.dataset.cmaRang, 10) || 0);
        }
        return;
      }

      var fBande = cible.closest('[data-cma-bande-pas]');
      if (fBande) {
        defilerBande(parseInt(fBande.dataset.cmaBandePas, 10) || 0);
        return;
      }

      var photo = cible.closest('[data-cma-photo]');
      if (photo) {
        var carteDeLaPhoto = photo.closest('[data-cma-carte]');
        /* La vignette ouvre SA photo : son rang dans l'avis est son index. */
        var rang = carteDeLaPhoto
          ? liste(carteDeLaPhoto, '[data-cma-photo]').indexOf(photo)
          : 0;
        ouvrirLoupe(carteDeLaPhoto, rang);
        return;
      }

      /* LE « +n » DE LA CARTE (G9.3) : il ouvre la loupe sur la premiere des
         photos qu'on ne montre pas, c'est-a-dire sur le rang qu'il porte. Les
         boutons cachees restent dans le DOM, donc la serie de la loupe et son
         compteur comptent bien TOUTES les photos de l'avis. */
      var plusPhotos = cible.closest('[data-cma-photos-plus]');
      if (plusPhotos) {
        ouvrirLoupe(
          plusPhotos.closest('[data-cma-carte]'),
          parseInt(plusPhotos.dataset.cmaPhotosPlus, 10) || 0
        );
        return;
      }

      if (loupe && cible.closest('[data-cma-loupe-fermer]')) {
        loupe.close();
        return;
      }

      var fleche = cible.closest('[data-cma-loupe-pas]');
      if (fleche) {
        naviguer(parseInt(fleche.dataset.cmaLoupePas, 10) || 0);
        return;
      }

      /* La carte entiere, en dernier : tous les elements qui ont leur propre
         geste ont deja rendu la main plus haut, et un lien ou un bouton qui
         viendrait a s'ajouter dans une carte garde le sien. Une selection de
         texte en cours n'est pas un clic : on ne l'interrompt pas. */
      var carte = cible.closest('[data-cma-carte]');
      if (carte && !cible.closest('a, button') && !texteSelectionne()) {
        ouvrirLoupe(carte, 0);
      }
    });

    function texteSelectionne() {
      var s = window.getSelection && window.getSelection();
      return !!(s && String(s).length);
    }

    /* Clavier : la carte est un point de tabulation (tabindex dans le Liquid),
       Entree et Espace l'ouvrent. Espace fait defiler la page par defaut, d'ou
       le preventDefault, et seulement quand la carte elle-meme a le focus :
       la vignette qu'elle contient garde son comportement de bouton natif. */
    racine.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      var carte = e.target && e.target.hasAttribute
        && e.target.hasAttribute('data-cma-carte') ? e.target : null;
      if (!carte) return;
      e.preventDefault();
      ouvrirLoupe(carte, 0);
    });

    if (loupe) {
      /* ── LE FOND, C'EST LE VOILE, ET RIEN QUE LUI (G18c, 07/09) ────────
         Retour de Raph : « quand tu cliques partout ailleurs que sur l'avis,
         ca doit revenir a la page produit ». Le geste existait, il ne pouvait
         simplement pas arriver sur un avis SANS PHOTO : le fond etait le
         dialogue lui-meme OU la scene (`data-cma-loupe-fond`), et un avis sans
         photo retire la scene, laissant `.cma-loupe-corps` couvrir tout
         l'ecran. Le clic tombait sur le corps, qui n'etait ni l'un ni l'autre,
         et rien ne se passait. C'est exactement la capture qu'il a envoyee.

         DEPUIS G18c LA QUESTION N'A PLUS QU'UNE REPONSE : la carte est bornee
         et centree (feuille), tout ce qui l'entoure est le dialogue lui-meme.
         `e.target === loupe` suffit donc, et il est JUSTE dans les deux sens :
         il ferme partout sur le voile, y compris sur les 16 px de marge, et il
         ne ferme nulle part dans la carte, scene comprise (elle est dedans,
         c'est la photo qu'on regarde).
         `data-cma-loupe-fond` est retire du Liquid avec cette ligne : il ne
         designait plus un fond.

         Un `<dialog>` modal recoit aussi les clics de son `::backdrop` sur
         lui-meme ; le notre est transparent et le dialogue couvre l'ecran, mais
         le chemin est le meme et la garde vaut pour les deux.
         Un glisse de zoom qui finit sur le voile n'est pas un clic sur le
         fond, d'ou la garde `glisse`. Echap : navigateur. */
      /* ── IL FAUT LES DEUX BOUTS DU GESTE, PAS SEULEMENT LE DERNIER ─────
         (fix G18c bis.) `click` n'est pas emis sur l'element relache : il est
         emis sur le PLUS PROCHE ANCETRE COMMUN de l'appui et du relachement.
         Un doigt (ou une souris) qui part du panneau de texte, glisse et
         relache sur le voile donne donc un `click` dont la cible est le
         dialogue lui-meme, exactement comme un vrai clic sur le fond : la vue
         se fermait au milieu d'une selection de texte ou d'un glissement
         avorte, et rien dans `e.target` ne permettait de faire la difference.
         On retient donc OU LE GESTE A COMMENCE, et la fermeture demande les
         deux bouts sur le voile. Le drapeau se repose a chaque appui, il ne
         peut donc pas survivre a un geste qui n'aurait pas donne de clic.
         Un « clic » du clavier (Entree sur une commande) n'a pas d'appui de
         pointeur, mais sa cible n'est jamais le dialogue : il ne passe pas par
         ici, et il n'a pas a le faire. */
      var appuiSurLeFond = false;
      loupe.addEventListener('pointerdown', function (e) {
        appuiSurLeFond = e.target === loupe;
      });
      loupe.addEventListener('click', function (e) {
        var partiDuFond = appuiSurLeFond;
        appuiSurLeFond = false;
        if (glisse) { glisse = null; return; }
        if (e.target === loupe && partiDuFond) loupe.close();
      });
      /* Les fleches du clavier parcourent les photos de l'avis ouvert, SAUF
         quand le focus est dans le panneau de texte : la, elles lui
         appartiennent (defilement, curseur de lecture d'un lecteur d'ecran). */
      loupe.addEventListener('keydown', function (e) {
        /* ECHAP, EN CLAIR. Le navigateur ferme deja un `<dialog>` modal par sa
           touche Echap (evenement `cancel`, puis `close`), mais cela ne se
           voit nulle part dans ce fichier et rien ne le prouve depuis une
           recette : on l'ecrit. `close()` sur un dialogue deja ferme ne fait
           rien et n'emet pas un second `close` : le chemin de fermeture reste
           unique, quel que soit celui des deux qui gagne la course. */
        if (e.key === 'Escape' || e.key === 'Esc') {
          if (loupe.open) loupe.close();
          return;
        }
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        if (loupeTexte && loupeTexte.contains(document.activeElement)) return;
        naviguer(e.key === 'ArrowRight' ? 1 : -1);
        e.preventDefault();
      });
      /* LE SEUL POINT DE SORTIE. Croix, clic sur le fond, Echap, `cancel` du
         navigateur : les quatre passent par `close()`, et `close` n'est emis
         qu'une fois. Tout ce qui doit etre defait l'est ici, verrou compris. */
      loupe.addEventListener('close', function () {
        deverrouille();
        /* Un glissement interrompu par Echap, ou celui qui vient de fermer la
           vue : la translation et le fondu sont defaits SANS transition, la
           vue d'apres s'ouvre a sa place et entiere. */
        tirer = null;
        tirerRemet(false);
        if (loupeImg) loupeImg.removeAttribute('src');
        if (loupeTexte) { loupeTexte.textContent = ''; loupeTexte.hidden = true; }
        vignettes = [];
        iPhoto = 0;
        pointeurs = {};
        zRemet(); /* echelle 1 ET `glisse` remis a zero pour la fois d'apres */
      });
    }

    rendu();
    reglerBande();
  }

  var blocs = liste(document, '[data-cma]');
  for (var i = 0; i < blocs.length; i++) monter(blocs[i]);
})();
